/**
 * Created by Jerker Nord on 2021-06-17.
 */

export interface SimpleReelModelSymbolData {
    name:string,
    positionable:Positionable,
    reelPosition:number
}

export interface Positionable {
    position:{
        x:number,
        y:number
    }
}

export interface SymbolPositionData {
    reelID:number;
    position:number;
    targetPosition:number;
}

export enum SimpleReelModelState {
    IDLE = "IDLE",
    START = "START",
    SPIN = "SPIN",
    READY_TO_STOP = "READY_TO_STOP",
    STOPPING = "STOPPING",
    STOPPED = "STOPPED",
    BOUNCE = "BOUNCE"
}

export enum WILD_2X2_NAMES {
    topPosition = "2x2_bot",
    fullPosition = "wild2X2",
    bottomPosition = "2x2_top"
}

export enum WILD_3X3_NAMES {
    topPosition = "3x3_1-3_bot",
    halfTopPosition = "3x3_2-3_bot",
    fullPosition = "wild3X3",
    halfBottomPosition = "3x3_2-3_top",
    bottomPosition = "3x3_1-3_top"
}

export enum WILD_2X2_SPLIT_NAMES {
    topPosition = "2x2_bot_Split_",
    fullPosition = "wild2X2_Split_",
    bottomPosition = "2x2_top_Split_"
}

export enum WILD_3X3_SPLIT_NAMES {
    topPosition = "3x3_1-3_bot_Split_",
    halfTopPosition = "3x3_2-3_bot_Split_",
    fullPosition = "wild3X3_Split_",
    halfBottomPosition = "3x3_2-3_top_Split_",
    bottomPosition = "3x3_1-3_top_Split_"
}

export enum SYMBOL_NAMES {
    M1 = "M1",
    M2 = "M2",
    M3 = "M3",
    M4 = "M4",
    M5 = "M5",
    L1 = "L1",
    L2 = "L2",
    L3 = "L3",
    L4 = "L4",
    L5 = "L5",
    S = "S",
    wild2X2 = "wild2X2",
    wild3X3 = "wild3X3",
    MX2 = "MX2"
}

export interface ISymbol {
    symbolName:string,
    reelPosition:number,
    reelId:number
    position:PIXI.Point,
    isRemoved:boolean,
    stackedSymbolName:string,
    isStacked:boolean
}

export enum LonerSymbolStates {
    NORMAL,
    NORMAL_FEATURE,
    SPIN_IN,
    TOGGLE_WIN,
    TOGGLE_NORMAL,
    NO_WIN,
    SPIN_OUT,
    SCATTER_TRANSFORMED,
    SCATTER_XWAYS,
    SCATTER_INFECTED,
    SCATTER_WILD,
    SCATTER_XSPLIT,
    SCATTER_TICK,
    SCATTER_TICK_TICK,
    SCATTER_BOOM,
    SCATTER_PIN,
    SCATTER_THE,
    SCATTER_WIN,
    SCATTER_SHOOT,
    SCATTER_SHOOT_SHOOT,
    SCATTER_DUCK,
    SPLIT2,
    SPLIT3,
    SPLIT4,
    SPLIT6,
    SPLIT8,
    M,
    A,
    X,
    SAD,
    SCATTER_MAX_WIN,
    INFECTED
}
